import React from "react";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-screen p-4">
      <div className="w-[280px] border rounded mt-3 ml-1 p-3 h-full">
        <div className="h-12">Setting 1</div>
        <div className="h-12">Setting 1</div>
        <div className="h-12">Setting 1</div>
        <div className="h-12">Setting 1</div>
        <div
          className="h-12 cursor-pointer"
          onClick={() => navigate("/new/settings/help-center")}
        >
          Help and Support
        </div>
      </div>
    </div>
  );
};

export default Settings;
